export default {
  governments: [],
  regions: [],
  cost: 0,
  governments_success: "",
  regions_success: "",
  required_regions: false,
  errors: [],
  error_msg: "",
};
